/**
 * 일시납 시작일을 쿼리에서 읽는다. 견적서의 `결제 바로가기` 가 견적과 같은 시작일로
 * 결제를 열기 위해 `onetimeStartDate=YYYY-MM-DD` 를 붙인다.
 *
 * 값이 없거나 형식이 틀리거나 과거면 undefined 를 돌려 기존 기본값(오늘)을 쓴다 —
 * 쿼리는 사용자가 고칠 수 있으므로 지난 날짜로 결제가 열리면 안 된다.
 */
export const determineOnetimeStartDate = (
  queryValue: string,
): Date | undefined => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(queryValue)) return undefined;

  const parsed = new Date(`${queryValue}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return undefined;

  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return parsed < today ? undefined : parsed;
};
